export function flyToCartFromButton(buttonEl: HTMLElement | null): void {
  let el: HTMLElement | null = buttonEl
  for (let i = 0; i < 6 && el; i++) {
    const img = el.querySelector("img")
    if (img) {
      flyToCart(img as HTMLElement)
      return
    }
    el = el.parentElement
  }
}

export function flyToCart(sourceEl: HTMLElement | null): void {
  if (!sourceEl || typeof window === "undefined") return
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return

  const target = document.querySelector<HTMLElement>("[data-cart-fly-target]")
  if (!target) return

  const imgEl = (sourceEl.querySelector("img") as HTMLElement | null) ?? sourceEl
  const srcRect = imgEl.getBoundingClientRect()
  if (srcRect.width === 0 || srcRect.height === 0) return
  const tgtRect = target.getBoundingClientRect()

  const clone = imgEl.cloneNode(true) as HTMLElement
  Object.assign(clone.style, {
    position     : "fixed",
    left         : `${srcRect.left}px`,
    top          : `${srcRect.top}px`,
    width        : `${srcRect.width}px`,
    height       : `${srcRect.height}px`,
    margin       : "0",
    borderRadius : "14px",
    objectFit    : "cover",
    zIndex       : "10000",
    pointerEvents: "none",
    boxShadow    : "0 12px 32px rgba(15,23,41,0.28)",
    willChange   : "transform, opacity",
  })
  document.body.appendChild(clone)

  const dx = tgtRect.left + tgtRect.width / 2 - (srcRect.left + srcRect.width / 2)
  const dy = tgtRect.top + tgtRect.height / 2 - (srcRect.top + srcRect.height / 2)

  const anim = clone.animate(
    [
      { transform: "translate(0px, 0px) scale(1)", opacity: 1, offset: 0 },
      { transform: `translate(${dx * 0.35}px, ${dy * 0.35 - 90}px) scale(0.55)`, opacity: 1, offset: 0.55 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.12)`, opacity: 0.35, offset: 1 },
    ],
    { duration: 720, easing: "cubic-bezier(0.45, 0, 0.2, 1)", fill: "forwards" },
  )

  anim.onfinish = () => {
    clone.remove()
    target.animate(
      [
        { transform: "scale(1)" },
        { transform: "scale(1.35)" },
        { transform: "scale(0.92)" },
        { transform: "scale(1)" },
      ],
      { duration: 420, easing: "cubic-bezier(0.34, 1.56, 0.64, 1)" },
    )
  }
}
